module.exports = __webpack_public_path__ + "static/img/daiyunying_dinggou.2d408c32.png";